<template>
  <div
    v-if="showPopup"
    class="modal right fade"
    id="opModal"
    tabindex="-1"
    aria-labelledby="OperationCreateModalLabel"
    style="z-index: 1055"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" @click.prevent="handleDialogClose">
            <span aria-hidden="true"
              ><i class="fa fa-times" style="color: #fff !important; font-weight: bold; font-size: 16px"></i
            ></span>
          </button>
          <span class="headerText" id="OperationCreateModalLabel" style="color: white">{{ newOperation }}</span>
        </div>

        <div class="modal-body">
          <div class="content">
            <div class="operation" :class="{ 'v4-op-layout': isV4CalculationEngine }">
              <div v-if="loading" style="position: relative; z-index: 999999; top: 22rem">
                <GridLoading></GridLoading>
              </div>
              <AlertComponent
                v-if="isCancelButtonClicked"
                @setWindow="$emit('visibleDialog', false)"
                :isCancelButtonClicked="isCancelButtonClicked"
                @hidePopup="isCancelButtonClicked = false"
                z-index="9999"
              ></AlertComponent>
              <div style="position: relative">
                <button class="btn btn-primary" style="width: 7rem; border-radius: 7px" @click="onSaveOperationData">
                  {{ $t("operationCreateComp.save") }}
                </button>
                <img style="padding: 28px; height: 121px; width: 175px" :src="imageUrl" alt="Selected Stitch" />
                <label v-if="isMultiComponentThreadEnabled" class="expandToComponents">
                  {{ $t("editComponent.expandToComponents") }}
                  <input
                    type="checkbox"
                    v-model="operationInputData.isMultiComponentThread"
                    @change="onExpandToComponentsChange"
                  />
                </label>
                <div class="entry">
                  <div class="inputGroup">
                    <label class="label" for="tbox1">{{ $t("operationCreateComp.group") }}</label>
                    <input
                      class="input"
                      type="number"
                      id="tbox1"
                      name="tbox1"
                      min="1"
                      value="operationInputData.group"
                      v-model="operationInputData.group"
                      required
                    />
                  </div>
                  <div class="team">
                    <label class="label" for="team">{{ $t("operationCreateComp.team") }}</label>
                    <div>
                      <toggle-button
                        v-model="operationInputData.isOnTeam"
                        :height="22"
                        :width="50"
                        checkedText="On"
                        uncheckedText="Off"
                        checkedBg=" #0054a6"
                        uncheckedBg="lightgrey"
                        color="#0054a6"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="body">
                <label class="label" for="description">{{ $t("operationCreateComp.description") }}</label>
                <textarea
                  name="tbox1"
                  class="textArea"
                  :class="{ errorStyle: descHasError }"
                  :maxlength="225"
                  :placeholder="addDescription"
                  rows="4"
                  cols="33"
                  :value="operationInputData.description"
                  @input="setDescriptionCounter($event.target)"
                  required
                  id="description"
                ></textarea>
                <span class="counter">{{ count }}/225</span>
              </div>

              <div
                class="stitchType-row"
                v-if="isV4CalculationEngine"
                style="display: flex; align-items: flex-end; gap: 24px"
              >
                <div class="stitchTypeWide" style="display: flex; flex-direction: column">
                  <label class="label1" for="operationType">{{ $t("editComponent.operationType") }}</label>
                  <ComboBox
                    id="operationType"
                    :data-source="operationTypeOptions"
                    :data-text-field="'label'"
                    :data-value-field="'value'"
                    :class="{ errorStyle: operationTypeHasError }"
                    :height="275"
                    :filter="'contains'"
                    :placeholder="'Select'"
                    v-model="operationInputData.operationType"
                    @change="handleOperationTypeChange($event.sender._cascadedValue)"
                    :style="{ width: '100% !important' }"
                  >
                  </ComboBox>
                </div>
              </div>

              <div class="stitchType-row" style="display: flex; align-items: flex-end; gap: 24px">
                <div class="stitchTypeWide" style="display: flex; flex-direction: column">
                  <label class="label1" for="stitchType">{{ $t("operationCreateComp.stitchType") }}</label>
                  <ComboBox
                    ref="stitchData"
                    :data-source="stitchTypeData?.[0]"
                    :class="{ errorStyle: stitchHasError }"
                    :height="275"
                    :maxlength="30"
                    :filter="'contains'"
                    :placeholder="'Select'"
                    v-model="operationInputData.stitchTypeCode"
                    @change="getStitchCode($event.sender._cascadedValue)"
                    :style="{ width: '100% !important' }"
                  >
                  </ComboBox>
                </div>
              </div>

              <div>
                <div class="formComponent" v-if="showSeamLength">
                  <!-- Button Hole/Bartack/Button Sew/Auto Cycle enter a stitch count here, not a length, so no unit is shown. -->
                  <label
                    v-if="isV4CalculationEngine && ['BH', 'BT', 'BS', 'AC'].includes(operationInputData.operationType)"
                    class="label"
                    for="seamlength"
                    >{{ $t("operationCreateComp.stitchCount") }}</label
                  >
                  <label v-else-if="seamLengthUnit == 0" class="label" for="seamlength"
                    >{{ $t("operationCreateComp.seamLength") }}(Cm)</label
                  >
                  <label v-else class="label" for="seamlength">{{ $t("operationCreateComp.seamLength") }}(inch)</label>
                  <input
                    class="input"
                    :class="{ errorStyle: seamLengthHasError }"
                    type="number"
                    min="0"
                    step=".01"
                    v-model="operationInputData.seamLength"
                    required
                    style="width: 9em !important"
                    id="seamlength"
                  />
                </div>
                <div class="formComponent" v-if="showRate">
                  <label v-if="seamLengthUnit == 0" class="label" for="stitch"
                    >{{ $t("operationCreateComp.stitch") }}/3Cm</label
                  >
                  <label v-else class="label" for="stitch">{{ $t("operationCreateComp.stitch") }}/inch</label>
                  <input
                    class="input"
                    type="number"
                    min="0"
                    step=".01"
                    v-model="operationInputData.rate"
                    style="width: 9em !important"
                    id="stitch"
                  />
                </div>
              </div>
              <div>
                <div class="formComponent" v-if="showQuantity">
                  <label class="label" for="quantity">{{ $t("operationCreateComp.row/Quantity") }}</label>
                  <input
                    class="input"
                    type="number"
                    min="1"
                    step=".01"
                    v-model="operationInputData.quantity"
                    style="width: 9em !important"
                    id="quantity"
                  />
                </div>
                <div class="formComponent">
                  <label class="label" for="machines">{{ $t("operationCreateComp.machines") }}</label>
                  <input
                    class="input"
                    :class="{ errorStyle: machineHasError }"
                    type="number"
                    min="1"
                    v-model="operationInputData.machines"
                    required
                    style="width: 9em !important"
                    id="machines"
                  />
                </div>
                <div class="formComponent" v-if="showSeamThickness && !isV4CalculationEngine">
                  <label class="label" for="seamThickness">{{ $t("operationCreateComp.seamThickness") }}(mm)</label>
                  <input
                    class="input"
                    :class="{ errorStyle: seamThicknessHasError }"
                    type="number"
                    min="1"
                    step=".1"
                    v-model="operationInputData.seamThikness"
                    style="width: 9em !important"
                    id="seamThickness"
                  />
                </div>
              </div>
              <div class="bight-row" v-if="showBight">
                <div class="formComponent" style="width: 25.5% !important; margin-top: 10px">
                  <label v-if="seamLengthUnit == 0" class="label" for="bight"
                    >{{ $t("operationCreateComp.bight") }}(mm)</label
                  >
                  <label v-else class="label" for="bight">{{ $t("operationCreateComp.bight") }}(inch)</label>
                  <input
                    class="input"
                    :class="{ errorStyle: bightHasError }"
                    type="number"
                    min="0"
                    step=".01"
                    v-model="operationInputData.bight"
                    @input="onBightChange"
                    style="width: 9em !important"
                    id="bight"
                  />
                </div>
              </div>
              <div class="seam-details-box" v-if="isV4CalculationEngine">
                <fieldset>
                  <legend>{{ $t("editComponent.seamDetails") }}</legend>

                  <div class="seam-row">
                    <label for="numberOfPlies">{{ $t("editComponent.numberOfPlies") }}</label>
                    <input
                      class="seam-input"
                      type="number"
                      min="1"
                      max="999999"
                      step="1"
                      v-model.number="operationInputData.numberOfPlies"
                      id="numberOfPlies"
                    />
                  </div>

                  <div class="seam-row">
                    <label for="avgMaterialThickness"
                      >{{ $t("editComponent.averageMaterialThickness") }} ({{ unitLabel }})</label
                    >
                    <input
                      class="seam-input"
                      type="number"
                      min="0"
                      max="999.99999"
                      step="0.00001"
                      v-model="materialThicknessDisplay"
                      id="avgMaterialThickness"
                    />
                  </div>

                  <div class="seam-row">
                    <label for="avgButtonThickness"
                      >{{ $t("editComponent.averageButtonThickness") }} ({{ unitLabel }})</label
                    >
                    <input
                      class="seam-input"
                      type="number"
                      min="0"
                      max="999.99999"
                      step="0.00001"
                      v-model="buttonThicknessDisplay"
                      id="avgButtonThickness"
                    />
                  </div>

                  <div class="seam-row">
                    <label for="avgThreadDiameter"
                      >{{ $t("editComponent.averageThreadDiameter") }} ({{ unitLabel }})</label
                    >
                    <input
                      class="seam-input"
                      type="number"
                      min="0"
                      max="999.99999"
                      step="0.00001"
                      v-model="threadDiameterDisplay"
                      id="avgThreadDiameter"
                    />
                  </div>

                  <div class="seam-row">
                    <label for="wastage">{{ $t("editComponent.wastagePerSeam") }} ({{ unitLabel }})</label>
                    <input
                      class="seam-input"
                      type="number"
                      min="0"
                      max="99999.99"
                      step="0.01"
                      v-model="wastagePerSeamDisplay"
                      id="wastage"
                    />
                  </div>

                  <div class="seam-row" v-if="showNeedleDistance">
                    <label for="needleDistance">{{ $t("editComponent.needleDistance") }} ({{ unitLabel }})</label>
                    <input
                      v-if="isNeedleDistanceEditable"
                      class="seam-input"
                      :class="{ errorStyle: needleDistanceHasError }"
                      type="number"
                      min="0"
                      :max="needleDistanceMax"
                      step="0.01"
                      v-model="needleDistanceDisplay"
                      id="needleDistance"
                    />
                    <span v-else class="seam-value">{{ needleDistanceDisplay }}</span>
                  </div>
                </fieldset>
              </div>
              <div class="footer">
                <div v-if="showHeader" class="child">
                  <table class="needlesTable">
                    <thead>
                      <tr>
                        <th>{{ $t("operationCreateComp.component") }}</th>
                        <th>{{ consumptionHeader }}</th>
                        <th>{{ $t("editComponent.brand") }}</th>
                        <th>{{ ticketTex == "Tkt" ? $t("editComponent.tkt") : $t("editComponent.tex") }}</th>
                        <th>{{ $t("editComponent.shade") }}</th>
                        <th>{{ $t("editComponent.packageSize") }}</th>
                      </tr>
                    </thead>
                    <tbody v-if="!operationInputData.isMultiComponentThread">
                      <tr v-for="(items, id) in componentsData" :key="id">
                        <td style="text-align: left">{{ items.name }}</td>
                        <td>{{ consumptionValues[id] }}</td>
                        <td>
                          <ComboBox
                            v-if="brandData.length"
                            :data-source="brandData.length ? brandData : []"
                            :data-text-field="'text'"
                            :height="130"
                            :data-value-field="'value'"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="brandIdDataArray[id]"
                            :value="brandIdDataArray[id]"
                            style="width: 10em !important; font-size: 12px !important"
                            @change="handleBrandChange($event.sender._cascadedValue, id)"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="tktTexData[id] && tktTexData[id].length ? tktTexData[id] : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="tktTexDataArray[id]"
                            :value="tktTexDataArray[id]"
                            style="width: 7em !important; font-size: 12px !important"
                            @change="handleTktTexChange($event.sender._cascadedValue, id)"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="shadeData.length ? shadeData : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="shadeDataArray[id]"
                            :value="shadeDataArray[id]"
                            style="width: 9em !important; font-size: 12px !important"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="packageSizeData[id] && packageSizeData[id].length ? packageSizeData[id] : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="packageSizeDataArray[id]"
                            :value="packageSizeDataArray[id]"
                            style="width: 7em !important; font-size: 12px !important"
                          >
                          </ComboBox>
                        </td>
                      </tr>
                    </tbody>
                    <!-- expanded to components - head row, then one row per part -->
                    <tbody v-else>
                      <tr
                        v-for="(row, rid) in componentDisplayRows"
                        :key="rid"
                        :class="{ headRow: row.isHead, componentRow: row.divisor > 1 }"
                      >
                        <td style="text-align: left">
                          {{ row.displayName }}
                          <span v-if="row.isHead" class="componentCount"> ({{ row.heads }})</span>
                        </td>
                        <td>{{ row.divisor > 1 ? row.consumption : consumptionValues[row.headPosition] }}</td>
                        <td v-if="row.isHead" colspan="4" class="chosenPerComponent">
                          {{ $t("editComponent.chosenPerComponentBelow") }}
                        </td>
                        <template v-else>
                          <td>
                            <ComboBox
                              v-if="brandData.length"
                              :data-source="brandData.length ? brandData : []"
                              :data-text-field="'text'"
                              :height="130"
                              :data-value-field="'value'"
                              :filter="'contains'"
                              :key="'id'"
                              v-model="brandIdDataArray[row.leafIndex]"
                              :value="brandIdDataArray[row.leafIndex]"
                              style="width: 10em !important; font-size: 12px !important"
                              @change="handleBrandChange($event.sender._cascadedValue, row.leafIndex)"
                            >
                            </ComboBox>
                          </td>
                          <td>
                            <ComboBox
                              :data-source="
                                tktTexData[row.leafIndex] && tktTexData[row.leafIndex].length
                                  ? tktTexData[row.leafIndex]
                                  : []
                              "
                              :data-text-field="'text'"
                              :data-value-field="'value'"
                              :height="130"
                              :filter="'contains'"
                              :key="'id'"
                              v-model="tktTexDataArray[row.leafIndex]"
                              :value="tktTexDataArray[row.leafIndex]"
                              style="width: 7em !important; font-size: 12px !important"
                              @change="handleTktTexChange($event.sender._cascadedValue, row.leafIndex)"
                            >
                            </ComboBox>
                          </td>
                          <td>
                            <ComboBox
                              :data-source="shadeData.length ? shadeData : []"
                              :data-text-field="'text'"
                              :data-value-field="'value'"
                              :height="130"
                              :filter="'contains'"
                              :key="'id'"
                              v-model="shadeDataArray[row.leafIndex]"
                              :value="shadeDataArray[row.leafIndex]"
                              style="width: 9em !important; font-size: 12px !important"
                            >
                            </ComboBox>
                          </td>
                          <td>
                            <ComboBox
                              :data-source="
                                packageSizeData[row.leafIndex] && packageSizeData[row.leafIndex].length
                                  ? packageSizeData[row.leafIndex]
                                  : []
                              "
                              :data-text-field="'text'"
                              :data-value-field="'value'"
                              :height="130"
                              :filter="'contains'"
                              :key="'id'"
                              v-model="packageSizeDataArray[row.leafIndex]"
                              :value="packageSizeDataArray[row.leafIndex]"
                              style="width: 7em !important; font-size: 12px !important"
                            >
                            </ComboBox>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p v-if="showHeader && !isV4CalculationEngine" class="wastageNote">
                  {{ $t("styleGrid.threadWastageNote") }}
                </p>

                <div class="buttons">
                  <button class="btn btn-primary" style="width: 7rem; border-radius: 5px" @click="onSaveOperationData">
                    {{ $t("operationCreateComp.save") }}
                  </button>
                  <button
                    class="btn btn-secondary"
                    style="width: 8rem; border-radius: 5px; margin-left: 10px"
                    @click="handleDialogClose"
                  >
                    {{ $t("operationCreateComp.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Dialog } from "@progress/kendo-vue-dialogs";
import { DropDownList, ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import AlertComponent from "./AlertComponent.vue";
import GridLoading from "./GridLoading.vue";
import { getConsumptionHeader } from "@/core/utils/ConsumptionHelper";
import {
  StitchTypeApi,
  StitchNBLCTypesApi,
  TicketTexApi,
  BrandApi,
  PackageSizeApi,
  ShadeApi,
  StyleOperationApi
} from "@/api";
import { OperationType, StyleOperationDto, StyleOperationNBLC } from "@/api/model";
import {
  buildDisplayRows,
  buildLeafRows,
  toHeadTypes,
  type ComponentDisplayRow
} from "@/core/utils/ComponentRowsHelper";
import { OPERATION_TYPE_OPTIONS, normalizeOperationType } from "@/core/utils/OperationTypeOptions";
import { isEditableNeedleDistanceStitchType } from "@/core/utils/EditableNeedleDistanceStitchTypes";
import { gsdV4StitchTypeNeedsBight, V4_DEFAULT_BIGHT_IN_MM, V4_MAX_BIGHT_IN_MM } from "@/core/utils/V4BightStitchTypes";
import { isInvalidOperationStitchType } from "@/core/utils/RestrictedOperationStitchTypes";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import VueToggles from "vue-toggles";

export default defineComponent({
  name: "OperationCreateComp",
  emits: ["visibleDialog", "getOperationData"],
  components: {
    "k-dialog": Dialog,
    ComboBox,
    DropDownList,
    "toggle-button": VueToggles,
    AlertComponent,
    GridLoading
  },
  props: {
    showPopup: null as any,
    setEditData: null as any,
    seamLengthUnit: null as any,
    consumptionData: null as any,
    ticketTex: null as any,
    calculationEngineType: {
      type: String,
      default: ""
    },
    isMultiComponentThreadEnabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    },
    consumptionHeader(): string {
      const stitchTypeCode = this.operationInputData?.stitchTypeCode ?? undefined;
      return getConsumptionHeader(this.seamLengthUnit, stitchTypeCode);
    },
    // Rows of the expanded thread table: head row + one row per part.
    componentDisplayRows(): ComponentDisplayRow[] {
      return buildDisplayRows(this.headTypes, true);
    },
    // Needle count comes from the stitch type's NBLC rows (loaded into needleCount when the stitch changes),
    // not from StitchType.Needles.
    selectedStitchNeedles(): number {
      return Number(this.needleCount ?? 0);
    },
    // True only when the new GSD V4 Bight rule applies to this operation. False means "leave everything
    // as it was", so on the Seamworks engine nothing changes, whether Bight is shown there or not.
    applyV4BightRule(): boolean {
      if (this.isV4CalculationEngine && gsdV4StitchTypeNeedsBight(this.operationInputData.stitchTypeCode)) {
        return true;
      } else {
        return false;
      }
    },
    // Editable for the listed GSD V4 stitch types; read-only (derived) for other multi-needle types.
    isNeedleDistanceEditable(): boolean {
      return this.isV4CalculationEngine && isEditableNeedleDistanceStitchType(this.operationInputData?.stitchTypeCode);
    },
    showNeedleDistance(): boolean {
      return this.isNeedleDistanceEditable || (this.isV4CalculationEngine && this.selectedStitchNeedles > 1);
    },
    needleDistance(): number {
      const needles = this.selectedStitchNeedles;
      if (needles <= 1) return 0;
      const bight = Number(this.operationInputData?.bight ?? 0);
      const value = Number((bight / (needles - 1)).toFixed(2));
      return Number.isFinite(value) ? value : 0;
    },
    // Upper bound shown to the user, in the box's unit (CM in metric, inch in imperial).
    needleDistanceMax(): number {
      return this.toNeedleDistanceDisplay(Number(this.operationInputData?.bight ?? 0));
    },
    // Needle distance is shown in the same unit as the other seam-detail fields (CM / inch). The value is held
    // internally in the Bight unit (mm / inch) for the <= Bight check, so metric display divides by 10.
    needleDistanceDisplay: {
      get(): any {
        const internal = this.operationInputData?.needleDistance;
        const value = internal === null || internal === undefined ? this.needleDistance : internal;
        return this.toNeedleDistanceDisplay(value);
      },
      set(value: any) {
        if (value === "" || value === null || value === undefined || Number.isNaN(Number(value))) {
          this.operationInputData.needleDistance = null;
          return;
        }
        this.operationInputData.needleDistance =
          this.seamLengthUnit == 0 ? Number((Number(value) * 10).toFixed(2)) : Number(value);
      }
    },
    unitLabel(): string {
      return this.seamLengthUnit == 0 ? "CM" : "inch";
    },
    // Display bindings: cm is always stored; inches are shown only in imperial. Untouched fields keep their exact cm.
    materialThicknessDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.materialThickness, 5);
      },
      set(value: any) {
        this.operationInputData.materialThickness = this.toCmValue(value, 5);
      }
    },
    buttonThicknessDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.buttonThickness, 5);
      },
      set(value: any) {
        this.operationInputData.buttonThickness = this.toCmValue(value, 5);
      }
    },
    threadDiameterDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.threadDiameter, 5);
      },
      set(value: any) {
        this.operationInputData.threadDiameter = this.toCmValue(value, 5);
      }
    },
    wastagePerSeamDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.wastagePerSeam, 2);
      },
      set(value: any) {
        this.operationInputData.wastagePerSeam = this.toCmValue(value, 2);
      }
    }
  },
  data() {
    return {
      toast: useToast(),
      visibleDialog: null as any,
      showBight: true,
      showSeamLength: true,
      showQuantity: true,
      showSeamThickness: true,
      showRate: true,
      stitchTypeData: [] as any,
      componentsData: [] as any,
      brandData: [] as any,
      tktTexData: [[], [], [], []] as any,
      packageSizeData: [[], [], [], []] as any,
      shadeData: [] as any,
      shadeDataArray: [] as any,
      needleData: [[], [], [], []] as any,
      brandId: null as any,
      tktTexId: null as any,
      packageSize: null as any,
      brandIdDataArray: [] as any,
      tktTexDataArray: [] as any,
      packageSizeDataArray: [] as any,
      shade: "",
      styleId: sessionStorage.getItem("styleId"),
      hasError: false,
      descHasError: false,
      stitchHasError: false,
      seamLengthHasError: false,
      machineHasError: false,
      seamThicknessHasError: false,
      numberOfPliesHasError: false,
      materialThicknessHasError: false,
      buttonThicknessHasError: false,
      threadDiameterHasError: false,
      wastagePerSeamHasError: false,
      needleDistanceHasError: false,
      bightHasError: false,
      operationStitchTypeHasError: false,
      operationTypeHasError: false,
      operationTypeOptions: OPERATION_TYPE_OPTIONS,
      operationInputData: {} as StyleOperationDto,
      loading: false,
      flag: false,
      stylesData: [] as any,
      loadingGrid: false,
      count: 0 as any,
      newOperation: this.$t("operationCreateComp.newOperation"),
      addDescription: this.$t("operationCreateComp.addDescriptionHere"),
      showHeader: false,
      saveFlag: false,
      isCancelButtonClicked: false,
      lastEnteredComponentsData: [] as any,
      // Head types of the stitch type with their parts, used only when expanded to components.
      headTypes: [] as any,
      // Rows as they were before ticking "Expand to Components", restored when it is unticked before saving.
      rowsBeforeExpand: null as any,
      unitOfMeasurement: sessionStorage.getItem("seamLengthUnit"),
      seamLengthUnitValue: sessionStorage.getItem("seamLengthUnit") == "Metric" ? 0 : 1,
      bightConversionFactor: 1,
      seamlengthConversionFector: 1,
      rateConversionFactor: 1,
      consumptionValues: [] as any,
      imageUrl: "/StitchTypeImages/EmptyImage.jpg",
      isStitchTypeValidation: [] as any,
      selectValueFromList: (this.$t("operationCreateComp.error") +
        ": " +
        this.$t("itemSelectModal.pleaseSelect") +
        " " +
        this.$t("itemSelectModal.fromTheList")) as string,
      defaultStitchData: [] as any,
      // Needle count for the selected stitch type, derived from its NBLC rows (sum of Heads for needle rows).
      needleCount: 0 as number
    };
  },
  setup() {
    const brandApi = new BrandApi()!;
    const ticketTexApi = new TicketTexApi()!;
    const shadeApi = new ShadeApi()!;
    const packageSizeApi = new PackageSizeApi()!;
    const stitchTypeApi = new StitchTypeApi()!;
    const stitchNBLCTypesApi = new StitchNBLCTypesApi()!;
    const styleOperationApi = new StyleOperationApi()!;
    return {
      brandApi,
      ticketTexApi,
      shadeApi,
      packageSizeApi,
      stitchTypeApi,
      stitchNBLCTypesApi,
      styleOperationApi
    };
  },
  created(): void {
    this.operationInputData.styleId = this.styleId as unknown as number;
    this.operationInputData.isOnTeam = true;
    this.operationInputData.wastagePerSeam = 0;
    this.operationInputData.operationType = OperationType.Sew;
    this.operationInputData.isMultiComponentThread = false;
    this.getStitchTypeData();
    this.getGroupNumber();
    this.setConversionFactor(this.seamLengthUnitValue);
    this.selectedImageUrl();
  },
  mounted() {
    if (this.showPopup) {
      this.$nextTick(() => {
        ($("#opModal") as any).modal("show");
        $("#opModal").on("shown.bs.modal", () => {
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) {
            backdrop.remove();
          }
        });
      });
    }
    ($("#opModal") as any)?.modal({
      backdrop: false,
      keyboard: false,
      focus: false
    });
  },
  methods: {
    handleBrandChange(selectedBrandId: any, id: any) {
      const isValid = this.brandData.some((item: any) => item.value == selectedBrandId);
      if (selectedBrandId === null || selectedBrandId === undefined || String(selectedBrandId).trim() === "") {
        this.isStitchTypeValidation[id] = true;
        this.brandIdDataArray[id] = selectedBrandId;
        this.tktTexData[id] = [];
        this.packageSizeData[id] = [];
        this.tktTexDataArray[id] = "";
      } else if (isValid) {
        this.isStitchTypeValidation[id] = true;
        this.brandIdDataArray[id] = selectedBrandId;
        this.tktTexData[id] = [];
        this.packageSizeData[id] = [];
        this.tktTexDataArray[id] = "";
        this.getTktTexData(selectedBrandId, id);
      } else {
        this.isStitchTypeValidation[id] = false;
        this.brandIdDataArray[id] = selectedBrandId;
        this.toast.error(this.selectValueFromList, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handleTktTexChange(selectedId: any, id: any) {
      const isValid = this.tktTexData[id].some((item: any) => item.value == selectedId);
      if (selectedId === null || selectedId === undefined || String(selectedId).trim() === "") {
        this.isStitchTypeValidation[id] = true;
        this.tktTexDataArray[id] = selectedId;
      } else if (isValid || selectedId === null || selectedId === undefined || String(selectedId).trim() === "") {
        this.isStitchTypeValidation[id] = true;
        this.tktTexDataArray[id] = selectedId;
        this.getPackageSizeData(selectedId, id);
      } else {
        this.isStitchTypeValidation[id] = false;
        this.toast.error(this.selectValueFromList, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handleDialogClose() {
      this.isCancelButtonClicked = true;
      this.backdropClose();
    },
    backdropClose() {
      setTimeout(() => {
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();

        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("padding-right");
      }, 300);
    },
    validateDescription(): boolean {
      if (this.operationInputData.description == null || this.operationInputData.description.trim() == "") {
        this.descHasError = true;
        this.toast.error(this.$t("operationCreateComp.pleaseEnterDescription") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.descHasError = false;
      }
      return this.descHasError;
    },
    setDescriptionCounter(target: EventTarget | null): void {
      const val = (target as HTMLInputElement).value;
      this.count = val.length;
      this.operationInputData.description = val.replace(",", " ");
    },
    setConsumptionData(StitchCode: string): void {
      this.consumptionValues = [];
      this.consumptionValues.push(
        this.consumptionData[StitchCode].headType1Consumption,
        this.consumptionData[StitchCode].headType2Consumption,
        this.consumptionData[StitchCode].headType3Consumption,
        this.consumptionData[StitchCode].headType4Consumption
      );
    },
    async getStitchTypeData(): Promise<void> {
      await this.stitchTypeApi
        .apiGetStitchTypesOrderByMostFrequentlyUsedGet(Number(sessionStorage.customSettingId))
        .then(async res => {
          let stitchType: any = [];
          for (let product of res.data) {
            stitchType.push(product.code + "-" + product.name);
          }
          this.stitchTypeData.push(stitchType);
          this.defaultStitchData.push(res.data);
        });
    },
    selectedImageUrl(): any {
      if (
        this.operationInputData.stitchTypeCode == null ||
        this.operationInputData.stitchTypeCode == undefined ||
        this.operationInputData.stitchTypeCode == ""
      ) {
        return `/StitchTypeImages/EmptyImage.jpg`;
      } else {
        const imageName = this.operationInputData.stitchTypeCode.replaceAll(/\s+/g, "");
        const imageUrl = `/StitchTypeImages/${imageName}.jpg`;
        switch (imageName) {
          case "1012":
          case "1013":
          case "1014":
          case "1016":
          case "3012":
          case "3013":
          case "3015":
          case "3042":
          case "3043":
          case "3045":
          case "4012":
          case "4013":
          case "4013G":
          case "4012G":
          case "4041":
          case "4042":
          case "4043":
          case "4045":
          case "4083": {
            this.imageUrl = "/StitchTypeImages/EmptyImage.jpg";
            break;
          }
          //the non ISO stitch types exist only for the GSD V4 engine, so they have no image under Seamworks.
          case "202":
          case "315":
          case "316":
          case "329":
          case "351":
          case "510":
          case "511":
          case "513":
          case "521":
          case "522":
          case "603":
          case "608": {
            this.imageUrl = this.isV4CalculationEngine ? imageUrl : "/StitchTypeImages/EmptyImage.jpg";
            break;
          }
          default: {
            this.imageUrl = imageUrl;
            break;
          }
        }
      }
    },
    async getStitchCode(stitchType: string): Promise<boolean> {
      // a new stitch type starts not expanded; tick again to split its rows
      this.operationInputData.isMultiComponentThread = false;
      this.rowsBeforeExpand = null;
      this.componentsData = [];
      this.lastEnteredComponentsData = [];
      this.shadeDataArray = [];
      if (stitchType == "" || stitchType == undefined || stitchType == null) {
        this.showHeader = false;
        this.stitchHasError = true;
        this.showBight = true;
        this.showSeamLength = true;
        this.showSeamThickness = true;
        this.showRate = true;
        this.showQuantity = true;
        this.imageUrl = "/StitchTypeImages/EmptyImage.jpg";
        this.toast.error(this.$t("operationCreateComp.pleaseSelectStitchType") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.stitchHasError = false;
        this.showHeader = true;
        this.operationInputData.stitchTypeCode = stitchType?.split("-")[0];
        //recompute the field visibility for the newly picked stitch type up front, the same way
        //EditComponent does, so the flags of the previously picked stitch type are never left behind.
        this.removingNonRequiredField();
        this.selectedImageUrl();
        this.loadNeedleCount(this.operationInputData.stitchTypeCode);
        this.setConsumptionData(this.operationInputData.stitchTypeCode);
        await this.styleOperationApi
          .apiGetRecentlyUsedStyleOperationStitchDataGet(
            this.styleId as unknown as number,
            stitchType?.split("-")[0] as string,
            this.seamLengthUnitValue
          )
          .then(async res => {
            if (Object.keys(res.data).length > 0) {
              this.operationInputData.seamLength = res.data.seamLength;
              this.operationInputData.quantity = res.data.quantity;
              this.operationInputData.bight = res.data.bight;
              this.operationInputData.rate = res.data.rate;
              this.operationInputData.machines = res.data.machines;
              this.operationInputData.seamThikness = res.data.seamThikness;
              this.lastEnteredComponentsData = res.data.styleOperations || [];
              if (this.isV4CalculationEngine) {
                // Prefill the GSD V4 seam-detail fields from the last saved operation for this stitch code.
                this.operationInputData.numberOfPlies = res.data.numberOfPlies ?? 1;
                this.operationInputData.materialThickness = res.data.materialThickness ?? null;
                this.operationInputData.buttonThickness = res.data.buttonThickness ?? null;
                this.operationInputData.threadDiameter = res.data.threadDiameter ?? null;
                this.operationInputData.wastagePerSeam = res.data.wastagePerSeam ?? 0;
                // Add operation: needle distance is derived from the formula (bight / (needleCount - 1)),
                // so leave it null and let needleDistanceDisplay compute it live.
                this.operationInputData.needleDistance = null;
                this.operationInputData.operationType =
                  normalizeOperationType(res.data.operationType) ?? OperationType.Sew;
              }
            } else {
              this.setDefaultData();
              if (this.isV4CalculationEngine) {
                // No prior operation for this stitch code — prefill V4 seam-detail fields from the
                // stitch type master (AppStitchTypes); fall back to defaults when the master has no value.
                const masterStitchType = this.defaultStitchData?.[0]?.find(
                  (item: any) => item.code == this.operationInputData.stitchTypeCode
                );
                this.operationInputData.numberOfPlies = masterStitchType?.numberOfPlies ?? 1;
                this.operationInputData.materialThickness = masterStitchType?.materialThickness ?? null;
                this.operationInputData.buttonThickness = masterStitchType?.buttonThickness ?? null;
                this.operationInputData.threadDiameter = masterStitchType?.threadDiameter ?? null;
                this.operationInputData.wastagePerSeam = masterStitchType?.wastagePerSeam ?? 0;
                // Add operation: needle distance is derived from the formula (bight / (needleCount - 1)),
                // so leave it null and let needleDistanceDisplay compute it live.
                this.operationInputData.needleDistance = null;
                this.operationInputData.operationType =
                  normalizeOperationType(masterStitchType?.operationType) ?? OperationType.Sew;
              }
            }
          });
        if (this.lastEnteredComponentsData.length > 0) {
          await this.getComponentData(this.operationInputData.stitchTypeCode as string);
          let expectedComponentsData = this.componentsData;
          this.componentsData = [];
          for (let [index, expected] of expectedComponentsData.entries()) {
            const needleName = expected.name?.trim()?.toLowerCase();

            const matchedVal = this.lastEnteredComponentsData.find(
              (val: any) => val.needleName?.trim()?.toLowerCase() === needleName
            );
            if (matchedVal) {
              this.componentsData.push({ name: matchedVal.needleName });
              this.getBrandData();
              this.brandIdDataArray[index] = matchedVal.brandId;
              this.getTktTexData(matchedVal.brandId, index);
              this.tktTexDataArray[index] = matchedVal.ticketTexId;
              this.getPackageSizeData(matchedVal.ticketTexId, index);
              this.packageSizeDataArray[index] = matchedVal.packageSizeId;
              this.shadeDataArray[index] = matchedVal.shade;
              this.getShadeData();
              this.removingNonRequiredField();
            } else {
              this.componentsData.push({ name: expected.name });
              this.brandIdDataArray[index] = null;
              this.tktTexDataArray[index] = null;
              this.packageSizeDataArray[index] = null;
              this.shadeDataArray[index] = null;
            }
          }
        } else {
          this.brandIdDataArray = [];
          this.tktTexDataArray = [];
          this.packageSizeDataArray = [];
          this.shadeDataArray = [];
          this.getComponentData(this.operationInputData.stitchTypeCode);
          this.removingNonRequiredField();
        }
        this.validateOperationStitchType();
      }
      return this.stitchHasError;
    },
    // Keep the operation type / stitch type pair checked as soon as either one is picked, so the
    // warning appears on selection; ValidateRequiredFields still re-checks it at save time.
    handleOperationTypeChange(operationType: OperationType): void {
      this.operationInputData.operationType = operationType;
      this.validateOperationStitchType();
    },
    // StitchType.Needles from the already-loaded stitch list; local fallback for the needle count.
    localStitchNeedleCount(stitchTypeCode?: string | null): number {
      const stitchList = this.defaultStitchData?.[0];
      const code = stitchTypeCode?.split("-")[0]?.trim();
      if (!Array.isArray(stitchList) || !code) return 0;
      const stitch = stitchList.find((item: any) => String(item.code) === String(code));
      return Number(stitch?.needles ?? 0);
    },
    // Load the needle count for the stitch type from its NBLC rows (sum of Heads across needle rows).
    async loadNeedleCount(stitchTypeCode?: string | null): Promise<void> {
      const code = stitchTypeCode?.split("-")[0]?.trim();
      if (!code) {
        this.needleCount = 0;
        return;
      }
      // Seed from local stitch metadata so non-listed stitch types keep their derived distance during
      // load and if the NBLC endpoint is unavailable (AC5); then refine with the authoritative NBLC count.
      this.needleCount = this.localStitchNeedleCount(code);
      try {
        const res = await this.stitchNBLCTypesApi.apiGetNeedleCountByStitchTypeCodeGet(code);
        // Guard against a stale response: if the user switched stitch type while this request was in
        // flight, the current stitch no longer matches and its needle count must not be overwritten.
        if (code !== this.operationInputData.stitchTypeCode?.split("-")[0]?.trim()) return;
        this.needleCount = Number(res.data ?? 0);
      } catch {
        // Keep the local fallback already set above.
      }
    },
    async getComponentData(stitchCode: string): Promise<void> {
      this.showHeader = true;
      this.componentsData = [];
      await this.stitchNBLCTypesApi.apiGetStitchNeedlesByStitchTypeCodeGet(stitchCode).then(async res => {
        for (let val of res.data) {
          let data = {
            name: val
          };
          this.componentsData.push(data);
        }
        this.getBrandData();
        this.getShadeData();
      });
    },
    // the rows as currently entered, in the same shape as the recently used data.
    currentRows(): StyleOperationNBLC[] {
      return this.componentsData.map((component: any, index: number) => {
        return {
          needleName: component.name,
          brandId: this.brandIdDataArray[index] ?? null,
          ticketTexId: this.tktTexDataArray[index] ?? null,
          packageSizeId: this.packageSizeDataArray[index] ?? null,
          shade: this.shadeDataArray[index] ?? null
        } as StyleOperationNBLC;
      });
    },
    // Show the given rows and fill the per-row selections from them, the same way the recently used data is applied.
    setRows(rows: StyleOperationNBLC[]): void {
      this.componentsData = rows.map(row => ({ name: row.needleName }));
      this.brandIdDataArray = [];
      this.tktTexDataArray = [];
      this.packageSizeDataArray = [];
      this.shadeDataArray = [];
      // a new empty Tkt/Tex and Package Size list for every row, so each row loads its own brand's list.
      // The other code expects at least 4 lists.
      let listCount = rows.length;
      if (listCount < 4) {
        listCount = 4;
      }
      this.tktTexData = [];
      this.packageSizeData = [];
      for (let i = 0; i < listCount; i++) {
        this.tktTexData.push([]);
        this.packageSizeData.push([]);
      }
      for (let [index, row] of rows.entries()) {
        if (row.brandId) {
          this.brandIdDataArray[index] = row.brandId;
          this.getTktTexData(row.brandId as any, index);
          this.tktTexDataArray[index] = row.ticketTexId;
          this.getPackageSizeData(row.ticketTexId as number, index);
          this.packageSizeDataArray[index] = row.packageSizeId;
          this.shadeDataArray[index] = row.shade;
        } else {
          // null (not undefined) so the dropdown clears the text it showed before
          this.brandIdDataArray[index] = null;
          this.tktTexDataArray[index] = null;
          this.packageSizeDataArray[index] = null;
          this.shadeDataArray[index] = null;
        }
      }
    },
    // Ticking splits the rows into one row per part, each starting with its head type's selection;
    // unticking before save brings back the rows as they were. Parts and their consumption come from the
    // consumption data the operation list loaded.
    onExpandToComponentsChange(): void {
      if (this.operationInputData.isMultiComponentThread) {
        this.rowsBeforeExpand = this.currentRows();
        const code = this.operationInputData.stitchTypeCode?.split("-")[0]?.trim() ?? "";
        this.headTypes = toHeadTypes(this.consumptionData?.[code]?.components ?? []);
        // each head type's selection is copied to all of its parts; the user then changes the ones that differ
        const copies: StyleOperationNBLC[] = [];
        for (const row of this.rowsBeforeExpand) {
          const head = this.headTypes.find((h: any) => h.name === (row.needleName ?? "").trim());
          const count = head ? head.heads : 1;
          for (let i = 0; i < count; i++) copies.push({ ...row });
        }
        this.setRows(buildLeafRows(this.headTypes, copies, true));
      } else {
        this.setRows(buildLeafRows(this.headTypes, [], false));
        this.rowsBeforeExpand = null;
      }
    },
    async getShadeData(): Promise<void> {
      this.shadeData = [];
      await this.shadeApi.apiShadeGetShadesOrderByMostFrequentlyUsedGet().then(async res => {
        for (let shade of res.data) {
          let data = {
            text: shade.name,
            value: shade.name
          };
          this.shadeData.push(data);
        }
      });
    },
    async getBrandData(): Promise<void> {
      this.brandData = [];
      await this.brandApi.apiGeBrandsOrderByMostFrequentlyUsedGet().then(async res => {
        for (let brand of res.data) {
          let data = {
            text: brand.name,
            value: brand.id
          };
          this.brandData.push(data);
        }
      });
    },
    async getTktTexData(brandId: number, id: number): Promise<void> {
      this.tktTexDataArray[id] = "";
      this.packageSizeDataArray[id] = "";
      let len = this.tktTexData[id].length;
      await this.ticketTexApi.apiGetTickeTexsByBrandIdGet(brandId).then(async res => {
        for (let value of res.data) {
          let ticketOrTex = this.ticketTex == "Tkt" ? value.ticket : value.tex;
          let data = {
            text: ticketOrTex,
            value: value.id
          };
          this.tktTexData[id].push(data);
        }
        this.tktTexData[id].reverse();
        for (let i = 0; i < len; i++) {
          this.tktTexData[id].pop();
        }
      });
    },
    async getPackageSizeData(tktTexId: number, id: number): Promise<void> {
      this.packageSizeDataArray[id] = "";
      let len = this.packageSizeData[id].length;
      await this.packageSizeApi.apiGetPacakageSizesByTicketTexIDGet(tktTexId).then(async res => {
        for (let val of res.data) {
          let data = {
            text: val.size,
            value: val.id
          };
          this.packageSizeData[id].push(data);
        }
        this.packageSizeData[id].reverse();
        for (let i = 0; i < len; i++) {
          this.packageSizeData[id].pop();
        }
      });
    },
    async getGroupNumber(): Promise<void> {
      this.loading = true;
      await this.styleOperationApi
        .apiGetGroupNumberGet(Number.parseInt(this.styleId ? this.styleId : ""))
        .then(async res => {
          this.operationInputData.group = res.data + 1;
          this.loading = false;
        });
    },
    validationForSeamLength(): boolean {
      // BH/BT/BS/AC hold a stitch count in this box, whose agreed data entry range is 0 to 9999999.99.
      const isStitchCount =
        this.isV4CalculationEngine && ["BH", "BT", "BS", "AC"].includes(String(this.operationInputData.operationType));
      if (
        (this.operationInputData.seamLength ? this.operationInputData.seamLength : 0) < 0 ||
        this.operationInputData.seamLength == undefined ||
        (isStitchCount && String(this.operationInputData.seamLength) === "")
      ) {
        this.seamLengthHasError = true;
        if (!isStitchCount)
          this.toast.error(this.$t("operationCreateComp.pleaseEnterSeamLength") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
      } else {
        // Over the agreed range: highlight the box in red only, no message.
        this.seamLengthHasError = isStitchCount && Number(this.operationInputData.seamLength) > 9999999.99;
      }
      return this.seamLengthHasError;
    },
    getMachine(): boolean {
      if (
        (this.operationInputData.machines ? this.operationInputData.machines : 0) <= 0 ||
        this.operationInputData.machines == undefined
      ) {
        this.machineHasError = true;
        this.toast.error(this.$t("operationCreateComp.pleaseEnterMachine") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.machineHasError = false;
      }
      return this.machineHasError;
    },
    validateSeamThickness(): void {
      if (this.isV4CalculationEngine) return;
      switch (this.operationInputData.stitchTypeCode) {
        case "301":
        case "319":
        case "401":
        case "401A":
        case "4012G":
        case "406":
        case "407":
        case "409":
        case "504":
        case "514":
        case "516":
        case "602":
        case "605":
        case "607":
        case "607K": {
          if ((this.operationInputData.seamThikness ? this.operationInputData.seamThikness : 0) <= 0) {
            this.seamThicknessHasError = true;
            this.toast.error(this.$t("operationCreateComp.seamThicknessShouldBeGreaterThan0") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          } else {
            this.seamThicknessHasError = false;
          }
          break;
        }
      }
    },
    // Number of plies: optional; integer 1–999999 when entered.
    validateNumberOfPlies(): boolean {
      this.numberOfPliesHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.numberOfPlies;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      if (isBlank) {
        // Plies is required under V4 and defaults to 1 — normalize a blank value so it's never sent as null.
        this.operationInputData.numberOfPlies = 1;
        return false;
      }
      const num = Number(raw);
      if (Number.isNaN(num) || !Number.isInteger(num) || num < 1 || num > 999999) {
        this.numberOfPliesHasError = true;
        this.toast.error(this.$t("editComponent.numberOfPliesError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.numberOfPliesHasError;
    },
    // In imperial the thickness/diameter/wastage fields are shown in inches; the value is always stored in cm.
    toDisplayValue(cmValue: any, decimals: number): any {
      if (cmValue === null || cmValue === undefined || cmValue === "") {
        return cmValue;
      }
      const num = Number(cmValue);
      if (Number.isNaN(num)) {
        return cmValue;
      }
      return this.seamLengthUnit == 1 ? Number((num / 2.54).toFixed(decimals)) : num;
    },
    toCmValue(displayValue: any, decimals: number): any {
      if (displayValue === null || displayValue === undefined || displayValue === "") {
        return null;
      }
      const num = Number(displayValue);
      if (Number.isNaN(num)) {
        return displayValue;
      }
      return this.seamLengthUnit == 1 ? Number((num * 2.54).toFixed(decimals)) : num;
    },
    // Needle distance is stored in the Bight unit (mm metric / inch imperial); show it in the box unit
    // (CM / inch), so metric divides by 10 while imperial (already inches, like the Bight field) is unchanged.
    toNeedleDistanceDisplay(internalValue: any): any {
      if (internalValue === null || internalValue === undefined || internalValue === "") {
        return internalValue;
      }
      const num = Number(internalValue);
      if (Number.isNaN(num)) {
        return internalValue;
      }
      return this.seamLengthUnit == 0 ? Number((num / 10).toFixed(2)) : num;
    },
    // Material thickness: required under V4; greater than 0 and up to 999.99999 (up to 5 dp).
    validateMaterialThickness(): boolean {
      this.materialThicknessHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.materialThickness;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (isBlank || Number.isNaN(num) || num <= 0 || num > 999.99999 || decimalPlaces > 5) {
        this.materialThicknessHasError = true;
        this.toast.error(
          this.$t("editComponent.materialThicknessError", { max: this.toDisplayValue(999.99999, 5) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.materialThicknessHasError;
    },
    // Button thickness: required (> 0) only for a Button Sew (BS) operation; otherwise 0 or blank is allowed.
    validateButtonThickness(): boolean {
      this.buttonThicknessHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.buttonThickness;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (this.operationInputData.operationType === "BS") {
        if (isBlank || Number.isNaN(num) || num <= 0 || num > 999.99999 || decimalPlaces > 5) {
          this.buttonThicknessHasError = true;
          this.toast.error(
            this.$t("editComponent.buttonThicknessRequiredError", { max: this.toDisplayValue(999.99999, 5) }) as string,
            {
              toastClassName: "custom-error-toast",
              timeout: 5000
            }
          );
        }
      } else if (!isBlank && (Number.isNaN(num) || num < 0 || num > 999.99999 || decimalPlaces > 5)) {
        this.buttonThicknessHasError = true;
        this.toast.error(
          this.$t("editComponent.buttonThicknessError", { max: this.toDisplayValue(999.99999, 5) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.buttonThicknessHasError;
    },
    // Thread diameter: required under V4; greater than 0 and up to 999.99999 (up to 5 dp).
    validateThreadDiameter(): boolean {
      this.threadDiameterHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.threadDiameter;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (isBlank || Number.isNaN(num) || num <= 0 || num > 999.99999 || decimalPlaces > 5) {
        this.threadDiameterHasError = true;
        this.toast.error(
          this.$t("editComponent.threadDiameterError", { max: this.toDisplayValue(999.99999, 5) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.threadDiameterHasError;
    },
    // Wastage per seam: optional; 0 to 99999.99 (up to 2 dp) when entered.
    validateWastagePerSeam(): boolean {
      this.wastagePerSeamHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.wastagePerSeam;
      const isBlank = raw === null || raw === undefined || (raw as unknown as string) === "";
      if (isBlank) {
        return false;
      }
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (Number.isNaN(num) || num < 0 || num > 99999.99 || decimalPlaces > 2) {
        this.wastagePerSeamHasError = true;
        this.toast.error(
          this.$t("editComponent.invalidWastagePerSeam", { max: this.toDisplayValue(99999.99, 2) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.wastagePerSeamHasError;
    },
    // Operation type: required under V4.
    validateOperationType(): boolean {
      this.operationTypeHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const value = this.operationInputData.operationType;
      if (value === null || value === undefined || String(value).trim() === "") {
        this.operationTypeHasError = true;
        this.toast.error(this.$t("editComponent.operationTypeError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.operationTypeHasError;
    },
    // Stitch type: always required. The dropdown's change handler sets this flag too, but it never runs
    // when the user leaves the dropdown untouched, so re-check the value here before saving.
    validateStitchType(): boolean {
      const value = this.operationInputData.stitchTypeCode;
      this.stitchHasError = value === null || value === undefined || String(value).trim() === "";
      if (this.stitchHasError) {
        this.toast.error(this.$t("operationCreateComp.pleaseSelectStitchType") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.stitchHasError;
    },
    // Distance between needle: editable for the listed GSD V4 stitch types; must be from 0.01 cm up to the Bight.
    validateNeedleDistance(): boolean {
      this.needleDistanceHasError = false;
      // A needle distance can never fit inside a wrong Bight, so only the Bight message is shown until it is corrected.
      if (!this.isNeedleDistanceEditable || this.bightHasError) {
        return false;
      }
      const raw = this.operationInputData.needleDistance;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const value = isBlank ? this.needleDistance : Number(raw);
      const bight = Number(this.operationInputData.bight ?? 0);
      // The smallest needle distance allowed is 0.01 cm (0.1 mm), converted into the unit the value is held in.
      const minNeedleDistance = 0.1 / this.bightConversionFactor;
      if (Number.isNaN(value) || value < minNeedleDistance || value > bight) {
        this.needleDistanceHasError = true;
        // A needle distance bigger than the Bight has its own message; every other wrong value gets the minimum message.
        const messageKey =
          value > bight ? "editComponent.needleDistanceGreaterThanBightError" : "editComponent.needleDistanceError";
        // The minimum is shown in the unit of the box at the same 5-decimal precision as the other seam-detail fields.
        const min = Number(this.toNeedleDistanceDisplay(minNeedleDistance).toFixed(5));
        this.toast.error(this.$t(messageKey, { min, unit: this.unitLabel }) as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.needleDistanceHasError;
    },
    // Bight: required for the listed GSD V4 stitch types, so it must be greater than 0.
    validateBight(): boolean {
      // An empty box gives 0, so this one check covers both an empty box and a wrong value.
      const bight = Number(this.operationInputData.bight);
      // Convert the limit into the unit the box is showing. Any Bight greater than 0 is allowed.
      const maxBight = V4_MAX_BIGHT_IN_MM / this.bightConversionFactor;
      if (this.applyV4BightRule && (bight <= 0 || bight > maxBight)) {
        // The flag highlights the Bight box in red until the value is corrected.
        this.bightHasError = true;
        // A Bight above the maximum has its own message; 0 or less gets the "greater than 0" message.
        const messageKey = bight > maxBight ? "editComponent.bightGreaterThanMaxError" : "editComponent.bightError";
        // The maximum is shown in the unit of the Bight box (mm or inch) at the 2-decimal precision of the box.
        const max = Number(maxBight.toFixed(2));
        const unit = this.bightConversionFactor == 1 ? "mm" : "inch";
        this.toast.error(this.$t(messageKey, { max, unit }) as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.bightHasError = false;
      }
      return this.bightHasError;
    },
    // Stitch type: only 101, 104, 107, 304 and 404 may be used with a Button Hole, Bartack or
    // Button Sew operation under V4. Other operation types are unaffected.
    validateOperationStitchType(): boolean {
      const { operationType, stitchTypeCode } = this.operationInputData;
      this.operationStitchTypeHasError =
        this.isV4CalculationEngine && isInvalidOperationStitchType(operationType, stitchTypeCode);
      if (this.operationStitchTypeHasError) {
        this.toast.error(this.$t("editComponent.buttonOperationStitchTypeError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.operationStitchTypeHasError;
    },
    ValidateRequiredFields(): boolean {
      this.validateDescription();
      this.validationForSeamLength();
      this.getMachine();
      this.validateSeamThickness();
      this.validateNumberOfPlies();
      this.validateMaterialThickness();
      this.validateButtonThickness();
      this.validateThreadDiameter();
      this.validateWastagePerSeam();
      this.validateBight();
      this.validateNeedleDistance();
      this.validateOperationType();
      this.validateStitchType();
      this.validateOperationStitchType();

      const hasBasicRequiredError =
        this.descHasError || this.stitchHasError || this.seamLengthHasError || this.machineHasError;
      if (hasBasicRequiredError) {
        this.toast.error(this.$t("operationCreateComp.pleaseFillRequiredData") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return (
        hasBasicRequiredError ||
        this.seamThicknessHasError ||
        this.numberOfPliesHasError ||
        this.materialThicknessHasError ||
        this.buttonThicknessHasError ||
        this.threadDiameterHasError ||
        this.wastagePerSeamHasError ||
        this.needleDistanceHasError ||
        this.bightHasError ||
        this.operationTypeHasError ||
        this.operationStitchTypeHasError
      );
    },
    resetStyleOperationData(): void {
      (this.$refs["stitchData"] as any).kendoWidget().text("");
      let groupId = Number(this.operationInputData.group) + 1;
      this.operationInputData = {
        stitchTypeCode: "",
        description: "",
        seamLength: 0,
        quantity: 1,
        bight: 0,
        rate: 0,
        group: groupId,
        machines: 1,
        isOnTeam: true,
        seamThikness: 1,
        styleId: this.operationInputData.styleId,
        styleOperations: null,
        numberOfPlies: 1,
        materialThickness: null,
        buttonThickness: null,
        threadDiameter: null,
        wastagePerSeam: 0,
        needleDistance: null,
        operationType: OperationType.Sew,
        isMultiComponentThread: false
      };
      this.showHeader = false;
      this.count = 0;
      this.brandIdDataArray = [];
      this.tktTexDataArray = [];
      this.packageSizeDataArray = [];
      this.shadeDataArray = [];
      this.componentsData = [];
      this.tktTexData = [[], [], [], []];
      this.packageSizeData = [[], [], [], []];
      this.imageUrl = "/StitchTypeImages/EmptyImage.jpg";
    },
    buildStyleOperations() {
      const shadeOperationData: StyleOperationNBLC[] = [];
      if (
        this.tktTexDataArray.length > 0 &&
        this.brandIdDataArray.length > 0 &&
        this.brandIdDataArray?.[0] !== "" &&
        this.tktTexDataArray?.[0] !== ""
      ) {
        for (let [index, component] of this.componentsData.entries()) {
          const styleOperationData: StyleOperationNBLC = {
            needleName: component.name,
            shade: this.shadeDataArray[index] == null ? this.shadeDataArray[index] : this.shadeDataArray[index].trim(),
            packageSizeId: this.packageSizeDataArray[index] == "" ? null : (this.packageSizeDataArray[index] as number),
            // a row without Tkt is left out (not sent as null): the API's TicketTexId is a plain int
            ticketTexId: this.tktTexDataArray[index] == null ? undefined : (this.tktTexDataArray[index] as number),
            brandId: this.brandIdDataArray[index]
          };
          shadeOperationData.push(styleOperationData);
        }
        return shadeOperationData;
      }
      return [];
    },
    async onSaveOperationData(): Promise<void> {
      try {
        this.flag = true;
        this.saveFlag = true;

        let isError: boolean = this.ValidateRequiredFields();
        if (isError) return;

        if (!this.isStitchTypeValidation.every(Boolean)) {
          this.toast.error(this.$t("operationCreateComp.errorInSavingOperation") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }
        // every part with a Brand needs its Tkt/Tex too before an expanded operation is saved
        if (this.operationInputData.isMultiComponentThread) {
          const partWithoutTkt = this.componentsData.some(
            (component: any, index: number) => !!this.brandIdDataArray[index] && !this.tktTexDataArray[index]
          );
          if (partWithoutTkt) {
            this.toast.error(this.$t("editComponent.selectTktForEveryComponent") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
            return;
          }
        }
        let shadeOperationData: StyleOperationNBLC[] = [];
        shadeOperationData = this.buildStyleOperations();

        const stitchOperationData: StyleOperationDto = {
          stitchTypeCode: this.operationInputData.stitchTypeCode,
          description: this.operationInputData.description?.trim(),
          seamLength: this.operationInputData.seamLength,
          quantity: Number.parseInt(this.operationInputData.quantity as unknown as string),
          bight: this.operationInputData.bight,
          rate: this.operationInputData.rate,
          group: this.operationInputData.group,
          machines: this.operationInputData.machines,
          isOnTeam: this.operationInputData.isOnTeam,
          seamThikness: this.isV4CalculationEngine ? 0 : this.operationInputData.seamThikness,
          styleId: this.operationInputData.styleId,
          styleOperations: shadeOperationData ?? [],
          seamLengthUnit: this.seamLengthUnitValue,
          numberOfPlies: this.isV4CalculationEngine ? (this.operationInputData.numberOfPlies ?? 1) : null,
          materialThickness: this.operationInputData.materialThickness ?? null,
          buttonThickness: this.operationInputData.buttonThickness ?? null,
          threadDiameter: this.operationInputData.threadDiameter ?? null,
          wastagePerSeam: this.isV4CalculationEngine ? (this.operationInputData.wastagePerSeam ?? 0) : null,
          needleDistance:
            this.operationInputData.needleDistance ?? (this.showNeedleDistance ? this.needleDistance : null),
          operationType: this.isV4CalculationEngine ? (this.operationInputData.operationType ?? null) : null,
          isMultiComponentThread: this.operationInputData.isMultiComponentThread ?? false
        };
        const result = await this.styleOperationApi.apiValidateAlreadyExistingOperationWithSameGroupPost(
          0,
          this.ticketTex || "",
          stitchOperationData || []
        );
        if (!result.data) {
          this.toast.error(this.$t("operationCreateComp.errorInSavingOperationWithSameGroup") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }
        const allEmpty = stitchOperationData.styleOperations?.every(
          item =>
            (item.brandId == null && item.brandId == undefined) ||
            (item.ticketTexId == null && item.ticketTexId == undefined)
        );
        const allValid = stitchOperationData.styleOperations?.every(
          item => item.brandId != null && item.brandId != undefined
        );
        if (!(allEmpty || allValid)) {
          this.toast.error(this.$t("operationCreateComp.errorInSavingOperation") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return;
        }
        try {
          const res = await this.styleOperationApi.apiSaveOperationPost(stitchOperationData);
          this.flag = false;

          if (res.data) {
            this.$emit("getOperationData");
            this.showBight = true;
            this.showSeamLength = true;
            this.showQuantity = true;
            this.showRate = true;
            this.showSeamThickness = true;
            this.toast.success(this.$t("operationCreateComp.operationSavedSuccessfully") as string, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
            this.resetStyleOperationData();
          } else {
            this.toast.error(this.$t("operationCreateComp.errorInSavingOperation") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          }
        } catch (error: any) {
          // Show the backend's localized UserFriendlyException message (set by the response interceptor).
          this.toast.error(error.errorMsg ?? (this.$t("operationCreateComp.errorInSavingOperation") as string), {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    onBightChange(): void {
      // For the listed (editable) stitch types the needle distance is entered by the user, so a bight change
      // must not overwrite it. For other stitch types it's the even-spacing default (bight / (needles - 1)),
      // so keep it in sync with the bight.
      if (!this.isV4CalculationEngine || this.isNeedleDistanceEditable) {
        return;
      }
      this.$nextTick(() => {
        this.operationInputData.needleDistance = this.needleDistance || null;
      });
    },
    setConversionFactor(unit: number): void {
      if (unit == 1) {
        this.bightConversionFactor = 25.4;
        this.seamlengthConversionFector = 2.54;
        this.rateConversionFactor = 1.181103;
      }
    },
    async setDefaultData(): Promise<void> {
      const stitchTypeFound = this.defaultStitchData[0].find(
        (item: any) => item.code == this.operationInputData.stitchTypeCode
      );
      switch (this.operationInputData.stitchTypeCode) {
        case "101":
        case "102":
        case "1014":
        case "103":
        case "104":
        case "105":
        case "107":
        case "108":
        case "201":
        case "204":
        case "205":
        case "206":
        case "209":
        case "211":
        case "213":
        case "214":
        case "215":
        case "217":
        case "219":
        case "220":
        case "317":
        case "318":
        case "404":
        case "405":
        case "411":
        case "412":
        case "413":
        case "414":
        case "415":
        case "416":
        case "417": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "301":
        case "319":
        case "401":
        case "401A": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showSeamThickness = true;
          this.operationInputData.seamThikness = stitchTypeFound?.seamThikness;
          this.showBight = false;
          break;
        }
        case "109":
        case "4041": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "327": {
          this.operationInputData.bight = (2 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "503": {
          this.operationInputData.bight = (2.5 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "302":
        case "303":
        case "304":
        case "305":
        case "306":
        case "307":
        case "308":
        case "309":
        case "310":
        case "311":
        case "312":
        case "314":
        case "322":
        case "324":
        case "326":
        case "402":
        case "403":
        case "410":
        case "501":
        case "502":
        case "505":
        case "506":
        case "507":
        case "508":
        case "509":
        case "512": {
          this.operationInputData.bight = (4 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "504":
        case "514": {
          this.operationInputData.bight = (4 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.seamThikness = stitchTypeFound?.seamThikness;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          break;
        }
        case "409": {
          this.operationInputData.bight = (4 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.operationInputData.seamThikness = stitchTypeFound?.seamThikness;
          break;
        }
        case "313":
        case "320":
        case "321":
        case "323":
        case "325":
        case "408":
        case "601":
        case "604":
        case "606":
        case "609": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "406":
        case "407":
        case "602":
        case "605":
        case "607":
        case "607K": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.showSeamThickness = true;
          this.operationInputData.seamThikness = stitchTypeFound?.seamThikness;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          break;
        }
        case "515": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "516": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.showSeamThickness = true;
          this.operationInputData.seamThikness = stitchTypeFound?.seamThikness;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          break;
        }
        case "328": {
          this.operationInputData.bight = (8 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "4083": {
          this.operationInputData.bight = (10 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "1013":
        case "3013":
        case "3043":
        case "4012":
        case "4013":
        case "4013G":
        case "4043": {
          this.operationInputData.seamLength = (2 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showRate = false;
          this.showSeamThickness = false;
          break;
        }
        case "4012G": {
          this.operationInputData.seamLength = (2 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.operationInputData.seamThikness = 1.5;
          this.showBight = false;
          this.showRate = false;
          break;
        }
        case "1015":
        case "3045":
        case "4045": {
          this.operationInputData.seamLength = (1 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "3015": {
          this.operationInputData.seamLength = (1 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "1012":
        case "1016":
        case "3012":
        case "3042":
        case "4042": {
          this.operationInputData.quantity = 1;
          this.operationInputData.machines = 1;
          this.operationInputData.seamLength = (1 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.showBight = false;
          this.showSeamLength = false;
          this.showRate = false;
          this.showSeamThickness = false;
          break;
        }
        //non ISO stitch types, sewn along a seam, so no seam thickness. Quantity and machines default to 1.
        case "315":
        case "316":
        case "329":
        case "351":
        case "510":
        case "511":
        case "513":
        case "521":
        case "522":
        case "603":
        case "608": {
          this.operationInputData.bight = ((stitchTypeFound.defaultBight * 10) / this.bightConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = true;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        case "202": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        default: {
          break;
        }
      }
      // GSD V4: the listed stitch types always take a Bight, whatever the switch above decided.
      if (this.applyV4BightRule) {
        this.showBight = true;
        // The stitch type stores its default in cm, so multiply by 10 to get mm.
        let bightInMm = Number(stitchTypeFound.defaultBight) * 10;
        if (bightInMm <= 0) {
          // This stitch type has no default of its own, so use the standard 3 mm.
          bightInMm = V4_DEFAULT_BIGHT_IN_MM;
        }
        this.operationInputData.bight = (bightInMm / this.bightConversionFactor).toFixed(2) as unknown as number;
      }
    },
    async removingNonRequiredField(): Promise<void> {
      switch (this.operationInputData.stitchTypeCode) {
        case "1012":
        case "1016":
        case "3012":
        case "3042":
        case "4042": {
          this.showBight = false;
          this.showSeamLength = false;
          this.showSeamThickness = false;
          this.showRate = false;
          break;
        }
        case "101":
        case "102":
        case "1014":
        case "103":
        case "104":
        case "105":
        case "107":
        case "108":
        case "201":
        case "204":
        case "205":
        case "206":
        case "209":
        case "211":
        case "213":
        case "214":
        case "215":
        case "217":
        case "219":
        case "220":
        case "317":
        case "318":
        case "404":
        case "405":
        case "411":
        case "412":
        case "413":
        case "414":
        case "415":
        case "416":
        case "417": {
          this.showBight = false;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "1013":
        case "3013":
        case "3043":
        case "4012":
        case "4013":
        case "4013G":
        case "4043": {
          this.showBight = false;
          this.showRate = false;
          this.showSeamThickness = false;
          break;
        }
        case "1015":
        case "109":
        case "3015":
        case "3045":
        case "4041":
        case "4045": {
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "302":
        case "303":
        case "304":
        case "305":
        case "306":
        case "307":
        case "308":
        case "309":
        case "310":
        case "311":
        case "312":
        case "313":
        case "314":
        case "320":
        case "321":
        case "322":
        case "323":
        case "324":
        case "325":
        case "326":
        case "327":
        case "328":
        case "402":
        case "403":
        case "408":
        case "4083":
        case "410":
        case "501":
        case "502":
        case "503":
        case "505":
        case "506":
        case "507":
        case "508":
        case "509":
        case "512":
        case "515":
        case "601":
        case "604":
        case "606":
        case "609": {
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "4012G": {
          this.showRate = false;
          this.showBight = false;
          break;
        }
        case "301":
        case "319":
        case "401":
        case "401A": {
          this.showBight = false;
          break;
        }
        case "406":
        case "407":
        case "504":
        case "514":
        case "602":
        case "605":
        case "607K":
        case "516":
        case "607": {
          this.showQuantity = false;
          break;
        }
        //non ISO stitch types always show quantity and machines, so set every flag explicitly.
        case "315":
        case "316":
        case "329":
        case "351":
        case "510":
        case "511":
        case "513":
        case "521":
        case "522":
        case "603":
        case "608": {
          this.showBight = true;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        case "202": {
          this.showBight = false;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        default: {
          break;
        }
      }
      // GSD V4: the listed stitch types always take a Bight, whatever the switch above decided.
      if (this.applyV4BightRule) {
        this.showBight = true;
      }
    }
  }
});
</script>
<style scoped>
.headerText {
  font-size: 16px;
}
.input {
  width: 95px;
  height: calc(1.4285714286em + 8px);
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  background-color: #ffffff;
  border-radius: 2px;
  text-align: right;
}
.label {
  font-size: 14px;
}
.inputGroup {
  display: grid;
  margin-top: 7px;
}
.team {
  margin-top: 7px;
  display: inline-grid;
  margin-left: 28px;
}
.entry {
  display: flex;
  margin-top: 10px;
  width: 48%;
}
.body {
  width: 100%;
  display: grid;
  margin-top: 15px;
  position: relative;
}
.textArea {
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  background-color: #ffffff;
  width: 100% !important;
  height: 85px !important;
}
.counter {
  position: absolute;
  bottom: 4px;
  right: 18px;
  color: #767474;
  font-size: 11px;
  background: #ffffff;
  padding: 0 2px;
  pointer-events: none;
}
.stitchType {
  display: inline-grid;
  margin-top: 10px;
}
.formComponent {
  display: inline-grid;
  width: 25.5% !important;
  margin-right: 12px !important;
  margin-top: 10px;
}
.parent {
  background-color: #d9d9de;
  display: flex;
  width: 100%;
  margin-top: 25px;
  justify-content: space-between;
  color: #575759;
  font-size: 15px;
  font-weight: 700;
  border: 1px solid #bebec1;
}
.heading {
  margin: 7px;
  font-size: 13px;
}
.child {
  width: 100%;
  margin-top: 5px;
  padding-left: 8px;
}
.vue-js-switch .v-switch-input {
  position: relative !important;
  opacity: 0 !important;
  width: 40px !important;
  height: 40px !important;
  top: 12px !important;
  left: 7px !important;
  z-index: 1000 !important;
}
.vue-js-switch .v-switch-core {
  display: block !important;
  position: relative !important;
  box-sizing: border-box !important;
  outline: 0 !important;
  margin: 0 !important;
  transition:
    border-color 0.3s,
    background-color 0.3s !important;
  top: -19px !important;
  left: 5px !important;
  user-select: none !important;
}
.vue-js-switch .v-switch-label {
  position: absolute !important;
  top: 9.5px !important;
  left: 30px !important;
  font-weight: 600 !important;
  color: #0054a6 !important;
  z-index: 1 !important;
}
.buttons {
  margin-top: 45px;
}
.wastageNote {
  margin: 12px 0 0 8px;
  font-size: 12px;
  color: #6c757d;
}
.expandToComponents {
  position: absolute;
  right: 0;
  top: 74px;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
}
.k-dialog-wrapper {
  align-items: flex-end !important;
}
.k-window-titlebar {
  color: #000000 !important;
  background-color: #ffffff !important;
}
.b-toaster {
  z-index: 999999 !important;
}
.errorStyle {
  border-color: red;
}
.k-input {
  font-size: 12px !important;
  padding: 0px 0px !important;
}

.modal-backdrop {
  z-index: 10400;
}

.btn-primary {
  background-color: #0054a6;
  color: white;
}
.modal-header {
  background-color: #0054a6;
  color: white;
  padding: 0.75rem;
  height: auto;
  border-top-left-radius: 0 !important;
}

.modal.right .modal-dialog {
  position: fixed;
  margin: 0;
  right: -1;
  top: 0;
  left: auto;
  bottom: 0;
  height: 100%;
  width: 55vw;
  max-width: 100vw;
  font-family: Arial, Helvetica, sans-serif;
  color: white;
}
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
  border-radius: 0 !important;
}

body.modal-open {
  overflow-x: hidden;
  border-radius: 0 !important;
}
.modal-header i.fa-times {
  color: white !important;
}
.custom-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1050;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.custom-backdrop.show {
  opacity: 1;
}
.modal {
  pointer-events: none !important;
}
.needlesTable {
  width: 100%;
  border: none;
  border-collapse: collapse;
  margin-top: 20px;
}
.needlesTable th,
.needlesTable td {
  padding: 4px;
  text-align: center;
  vertical-align: middle;
}
.needlesTable th {
  background: #d9d9de;
  color: #575759;
  font-size: 14px;
  font-weight: 700;
}
/* expanded thread rows */
.needlesTable tr.headRow td {
  background: #f7f8fa;
  font-weight: 600;
}
.needlesTable tr.headRow .componentCount {
  font-weight: 400;
  color: #666;
}
.needlesTable tr.headRow .chosenPerComponent {
  text-align: left;
  color: #8a8f98;
  font-weight: 400;
}
.needlesTable tr.componentRow td:first-child {
  padding-left: 28px;
}
.modal.right .modal-dialog {
  width: 60vw !important;
  max-width: 55vw !important;
}

.modal-body {
  padding: 16px !important;
}

.operation {
  color: #000;
}

.operation img {
  float: none !important;
  position: absolute;
  right: 0;
  top: 0;
  width: 120px !important;
  height: 58px !important;
  padding: 0px !important;
  border: 1px dashed #cfd6df;
  object-fit: contain;
}

.body,
.stitchType {
  width: 48% !important;
}
.v4-op-layout .formComponent {
  width: 22% !important;
}
.formComponent .input {
  width: 100% !important;
}

.stitchType-row {
  margin-top: 10px;
}

.stitchTypeWide {
  width: calc(51% + -36px);
}

.seam-details-box {
  position: absolute;
  right: 12px;
  top: 96px;
  width: 48% !important;
  color: #000;
  font-family: inherit;
}

.seam-details-box fieldset {
  border: 1px solid #cfd6df;
  padding: 12px 14px;
  min-height: 168px;
  margin-top: 15%;
}

.seam-details-box legend {
  width: auto;
  max-width: fit-content;
  font-size: 14px;
  font-weight: 400;
  padding: 0 6px;
  margin-left: 10px;
  margin-bottom: 0;
  color: #000;
  float: none;
}

.seam-row {
  display: grid;
  grid-template-columns: 1fr 130px;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.seam-row label {
  width: auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: inherit;
  margin-bottom: 0;
}

.seam-input {
  width: 130px;
  height: 28px;
  text-align: right;
  border: 1px solid #cfd6df;
}

.seam-value {
  height: 28px;
  border: 1px solid #cfd6df;
  border-radius: 2px;
  padding: 0 8px;
  font-size: 14px;
  /* Read-only field: muted text + grey fill signal it isn't editable. */
  color: #9ca3af;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.footer {
  clear: both;
  margin-top: 25px;
}
.buttons {
  margin-top: 22px !important;
}
</style>

<!-- Non-scoped: Kendo appends the ComboBox popup to <body>, so scoped styles can't reach it.
     Scoped by the popup id so ONLY the Operation Type list is affected. Neutralise the global
     blue "selected" highlight so the open list matches the Stitch Type dropdown. -->
<style>
#operationType_listbox .k-list-item.k-selected,
#operationType_listbox .k-item.k-state-selected,
#operationType_listbox .k-list-optionlabel.k-state-selected {
  color: #333333 !important;
  background-color: #ffffff !important;
}
#operationType_listbox .k-list-item.k-selected.k-hover,
#operationType_listbox .k-list-item.k-selected:hover,
#operationType_listbox .k-item.k-state-selected.k-state-hover,
#operationType_listbox .k-item.k-state-selected:hover {
  background-color: #ebebeb !important;
}
</style>
